import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

const API_URL = `${import.meta.env.VITE_FOUNDATION_API}/nsportal/Users`;

export const RESEND_VERIFICATION_USER = 'resend-verification-user';

async function query(userId?: string) {
  const response = await axios.post(`${API_URL}/${userId}/resend-verification`);
  return response.data;
}

export function useResendVerificationUser(userId?: string) {
  return useMutation({
    mutationKey: [RESEND_VERIFICATION_USER, userId],
    mutationFn: (userId: string) => query(userId),
  });
}
